import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsChevronRight } from '@deephaven/icons';
import "./MenuItem.css";
import UISwitch from "../UISwitch.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function isSwitchMenuItemType(item) {
  return item.isOn !== undefined;
}
/**
 * @param props.item The menu item to set. Set a SwitchMenuItemDef to show a switch.
 * @param props.onSelect Called when the menu item is selected
 */
export function MenuItem(_ref) {
  var item = _ref.item,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? () => undefined : _ref$onSelect,
    dataTestId = _ref['data-testid'];
  var icon = item.icon,
    subtitle = item.subtitle,
    title = item.title;
  var handleSelect = useMemo(() => {
    if (isSwitchMenuItemType(item)) {
      return () => {
        item.onChange(!item.isOn);
      };
    }
    return onSelect;
  }, [item, onSelect]);
  return /*#__PURE__*/_jsxs("div", {
    className: "btn btn-navigation-menu-item",
    "data-testid": "menu-item-".concat(title),
    onClick: handleSelect,
    onKeyDown: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        handleSelect();
      }
    },
    tabIndex: 0,
    role: "menuitem",
    children: [icon !== undefined && /*#__PURE__*/_jsx("div", {
      className: "icon",
      children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: icon
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "title",
      children: title
    }), subtitle !== undefined && /*#__PURE__*/_jsx("div", {
      className: "shortcut",
      children: subtitle
    }), /*#__PURE__*/_jsx("div", {
      className: "accessory",
      "data-testid": dataTestId,
      children: isSwitchMenuItemType(item) ? /*#__PURE__*/_jsx(UISwitch, {
        on: item.isOn,
        onClick: event => {
          event.stopPropagation();
          handleSelect();
        }
      }) : /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsChevronRight
      })
    })]
  });
}
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map